// extracted by mini-css-extract-plugin
export default {"doc-link":"bK7h","docLink":"bK7h"};